import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AppState } from '@app/app.service';
import { ModalHelper } from '@services/modal-helper.service';
import { ToastrHelperService } from '@services/toast-helper.service';
import { PhonePipe } from '@widgets/pipes/phone.pipe';
import { UserAccountServiceNoSync } from '@ztarmobile/zwp-service-backend';
import { takeWhile } from 'rxjs';
import { ACCOUNT_ROUTE_URLS, SUPPORT_ROUTE_URLS } from 'src/app/app.routes.names';

@Component({
  selector: 'app-fifth-generation-page',
  templateUrl: './fifth-generation-page.component.html',
  styleUrls: ['./fifth-generation-page.component.scss']
})

export class AndroidFifthGenerationPageComponent implements OnInit, OnDestroy {
  public ACCOUNT_ROUTE_URLS = ACCOUNT_ROUTE_URLS;
  public instructionTable = [
    { key: 'Name:', value: 'FreeUp Mobile' },
    { key: 'APN:', value: 'eRESELLER' },
    { key: 'Proxy:', value: 'Not set' },
    { key: 'Port:', value: 'Not set' },
    { key: 'Username:', value: 'Not set' },
    { key: 'Password:', value: 'Not set' },
    { key: 'Server:', value: 'Not set' },
    { key: 'MMSC:', value: 'http://mmsc.mobile.att.net', href: true },
    { key: 'MMS Proxy:', value: 'proxy.mobile.att.net', href: false },
    { key: 'MMS Port:', value: '80' },
    { key: 'MCC:', value: '310' },
    { key: 'MNC:', value: '410' },
    { key: 'Authentication Type:', value: 'None' },
    { key: 'APN Type:', value: 'default,supl,mms,fota' },
    { key: 'APN protocol:', value: 'IPv4/IPv6' },
    { key: 'Bearer:', value: 'Unspecified' }
  ];
  public mdn: string;

  private alive = true;

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private userAccountService: UserAccountServiceNoSync,
    private appState: AppState,
    private toastHelper: ToastrHelperService,
    private modalHelper: ModalHelper) { }


  ngOnInit(): void {
    this.route.params.pipe(takeWhile(() => this.alive)).subscribe((params: Params) => {
      if (!!params) {
        if (!!params[SUPPORT_ROUTE_URLS.PARAMS.MDN]) {
          this.mdn = params[SUPPORT_ROUTE_URLS.PARAMS.MDN];
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.alive = false;
  }

  public back(): void {
    this.router.navigate([`${SUPPORT_ROUTE_URLS.BASE}/${SUPPORT_ROUTE_URLS.ATT_ANDROID}`]);
  }

  public enable5G(): void {
    const enableCustomHtml = `<p>Please make sure you applied the instructions above to <b>enable</b> the <b>5G settings</b> on your <b>MDN</b>:</p>
                                <p class="mdn"><b>${(new PhonePipe()).transform(this.mdn)}</b></p>`;
    this.modalHelper.showFiveGModal('Enable 5G', enableCustomHtml, 'Confirm & Download file',
      '/assets/ereseller.mobileconfig', 'five-toggle-modal', true).afterClosed().subscribe((res) => {
        if (!!res) {
          this.appState.loading = true;
          //the timeout needs to be set to fixte issue of downloading in firefox and safari
          setTimeout(() => {
            this.userAccountService.enable5G(this.mdn).then((result) => {
              if (!!result) {
                this.appState.loading = false;
                this.showSuccessModal();
              }
            }, (error) => {
              this.appState.loading = false;
              this.toastHelper.showAlert(error.message);
            });
          }, 2000);
        } else {
          this.appState.loading = false;
        }
      });
  }

  private showSuccessModal(): void {
    this.modalHelper.successModal('Your 5G has been enabled successfully', 'Done', 'success-modal').afterClosed().subscribe((res) => {
      if (!!res) {
        this.userAccountService.selectedAccount.pipe(takeWhile(() => this.alive)).subscribe((account) => {
          if (!!account) {
            const userAccount = account;
            userAccount.tech5gEnabled = true;
            this.router.navigate([`${ACCOUNT_ROUTE_URLS.BASE}/${ACCOUNT_ROUTE_URLS.SUMMARY}`]);
          }
        });
      }
    });
  }

  @HostListener("window:keydown.esc", ["$event"])
  onEsc(event: any): void {
    if (event.keyCode === 27) {
      event.preventDefault();
      if (document.querySelector('body div.success-modal')) {
        this.showSuccessModal();
      }
    }
  }
}
